/* eslint-disable camelcase */
import AspectWrapper from 'components/wrappers/AspectWrapper';
import BackgroundSwitch from 'components/background/BackgroundSwitch';
import ColumnsLayout from 'components/contentLayouts/ColumnsLayout';
import InformationBlock from 'libs/wordpress/content/cmsBlocks/InformationBlock';
import MaxWidthWrapper from 'components/wrappers/MaxWidthWrapper';
import PropTypes from 'prop-types';
import React from 'react';
import { bleedMargins } from 'config/theme/contentMargins';
import { mediaQueries } from 'config/theme/breakpoints';
import moduleMargins from 'config/theme/moduleMargins';
import styled from 'libs/styled';
import transformFlexibleBackground from 'libs/wordpress/utils/transformFlexibleBackground';
import useAboveBreakpoint from 'hooks/useAboveBreakpoint';

const InformationBlockWrapper = styled('div', { shouldForwardProp: prop => ['columnStyles'].indexOf(prop) === -1 })``;

const InformationModule = ({ content }) => {
    const {
        background_media_flexible: backgroundFlexible,
        content: { content_alignment: contentAlignment },
    } = content;

    const contentLeft = contentAlignment === 'left';

    // Tranform Background Data
    const isAboveSm = useAboveBreakpoint('sm');
    const transformedBackground = transformFlexibleBackground(backgroundFlexible);
    const mobileBackground = transformedBackground.mobile;
    const desktopBackground = transformedBackground.desktop;

    return (
        <MaxWidthWrapper includeContentMargins as="section" my={moduleMargins.xxs}>
            <ColumnsLayout
                blocks={[
                    <AspectWrapper
                        key="image"
                        mx={[bleedMargins[0], bleedMargins[1], '0']}
                        order={contentLeft ? [1, null, 2] : 1}
                        ratio={3 / 4}
                    >
                        <BackgroundSwitch
                            background={isAboveSm ? desktopBackground : mobileBackground}
                            type={isAboveSm ? desktopBackground.type : mobileBackground.type}
                            mediaQuery={mediaQueries.twoColumn}
                        />
                    </AspectWrapper>,
                    <InformationBlockWrapper
                        columnStyles={{ mr: 'auto' }}
                        height={[null, null, '100%']}
                        key="information"
                        order={contentLeft ? [2, null, 1] : 2}
                        p={['0 12px', null, '24px 0']}
                    >
                        <InformationBlock isColumn content={content} />
                    </InformationBlockWrapper>,
                ]}
                columnSizes={[12, null, 6]}
            />
        </MaxWidthWrapper>
    );
};

InformationModule.propTypes = {
    content: PropTypes.shape({
        content: PropTypes.shape({
            content_alignment: PropTypes.oneOf(['left', 'right']),
        }),
        background_media_flexible: PropTypes.exact({
            mobile: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.object])),
            desktop: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.object])),
        }),
    }).isRequired,
};

export default InformationModule;
